import React from "react";
import CheckWorkerInfo from "../../screens/auth/CheckWorkerInfo";
import { MockedProvider } from "@apollo/client/testing/react";
import type { Meta, StoryObj } from "@storybook/react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { StoryStackNavigatorContainer } from "../display-helpers";

const Stack = createNativeStackNavigator<{
    CheckWorkerInfo: undefined;
}>();

const StoryComponent = () => {
    return (
        <MockedProvider mocks={[]}>
            <StoryStackNavigatorContainer>
                <Stack.Navigator initialRouteName="CheckWorkerInfo">
                    <Stack.Screen name="CheckWorkerInfo" component={CheckWorkerInfo} />
                </Stack.Navigator>
            </StoryStackNavigatorContainer>
        </MockedProvider>
    );
};

const meta = {
    title: "Screens/Check worker info",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
